/* ==========================================================================
   LOVE LACE — shopping interactions (ll-shop.js)
   Cart drawer · quick add · quick view · variant selection · recommendations.
   Shopify Ajax Cart API + Section Rendering API only (no libraries).
   Product-page "Add to bag" is routed into the same drawer. Checkout and
   Buy-it-now are untouched.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document, win = window;
  var LL = win.LoveLace || { routes: {}, strings: {} };
  var R = LL.routes, S = LL.strings;
  var DRAWER_SECTION = 'll-cart-drawer';
  var lastFocus = null;

  function $(sel, scope) { return (scope || doc).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || doc).querySelectorAll(sel)); }
  function formatMoney(cents) {
    var fmt = LL.moneyFormat || '£{{amount}}';
    var n = (cents / 100);
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
              .replace(/\{\{\s*amount\s*\}\}/, two)
              .replace(/<[^>]*>/g, '');
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(msg) {
    var t = $('[data-ll-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function overlay(on) { var o = $('[data-ll-overlay]'); if (o) o.classList.toggle('is-visible', on); }
  function lock(on) { doc.body.classList.toggle('ll-lock', on); }
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var f = $all('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- cart drawer ---------------- */
  function drawer() { return $('#LLCartDrawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    closeModal(true);
    lastFocus = lastFocus || doc.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    overlay(true); lock(true);
    setTimeout(function () { var c = $('[data-ll-close]', d); c && c.focus(); }, 80);
    loadRecs();
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    overlay(false); lock(false);
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 620);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }
  function renderDrawer(html) {
    if (!html) return;
    var d = drawer(); if (!d) return;
    var tmp = doc.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#LLCartDrawer'); if (!fresh) return;
    d.innerHTML = fresh.innerHTML;
    var count = parseInt(fresh.getAttribute('data-cart-count'), 10) || 0;
    d.setAttribute('data-cart-count', count);
    updateCount(count);
    if (d.classList.contains('is-open')) loadRecs();
  }
  function updateCount(count) {
    $all('[data-ll-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
    $all('[data-ll-cart-open]').forEach(function (el) { el.setAttribute('aria-label', 'Bag, ' + count + ' items'); });
    $all('[data-cart-count]').forEach(function (el) { if (!el.closest('#LLCartDrawer')) el.textContent = count; });
  }
  function refreshDrawer() {
    return fetch((R.root || '/').replace(/\/$/, '') + '/?sections=' + DRAWER_SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { renderDrawer(j[DRAWER_SECTION]); });
  }

  var recsCache = {};
  function loadRecs() {
    var d = drawer(); if (!d) return;
    var box = $('[data-ll-recs]', d); if (!box) return;
    var pid = box.getAttribute('data-rec-for'); if (!pid) return;
    var grid = $('[data-ll-recs-grid]', box);
    var inCart = $all('[data-line-key][data-product-id]', d).map(function (li) { return li.getAttribute('data-product-id'); });
    var paint = function (products) {
      var list = (products || []).filter(function (p) { return inCart.indexOf(String(p.id)) === -1; }).slice(0, 3);
      if (!list.length) { box.hidden = true; return; }
      grid.innerHTML = list.map(function (p) {
        var src = p.featured_image || '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        var img = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
        return '<a class="ll-rec" href="' + p.url + '"><span class="ll-rec__img" style="display:block">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="300" height="400">' : '') + '</span><span class="ll-rec__title">' + escapeHtml(p.title) + '</span><span class="ll-rec__price">' + formatMoney(p.price) + '</span></a>';
      }).join('');
      box.hidden = false;
    };
    if (recsCache[pid]) return paint(recsCache[pid]);
    fetch(R.recs + '?product_id=' + pid + '&limit=6', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { recsCache[pid] = j.products; paint(j.products); })
      .catch(function () { box.hidden = true; });
  }

  /* ---------------- add to cart ---------------- */
  function addToCart(body, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var isForm = body instanceof FormData;
    if (isForm) { body.append('sections', DRAWER_SECTION); body.append('sections_url', win.location.pathname); }
    else { body.sections = DRAWER_SECTION; body.sections_url = win.location.pathname; }
    return fetch(R.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: isForm ? { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) {
      if (j.sections && j.sections[DRAWER_SECTION]) renderDrawer(j.sections[DRAWER_SECTION]);
      else return refreshDrawer();
    }).then(function () {
      if (!openDrawer()) toast(S.added);
      doc.dispatchEvent(new CustomEvent('ll:cart:added'));
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || S.error);
      throw err;
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  }

  function changeLine(key, qty, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    return fetch(R.cartChange, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: DRAWER_SECTION, sections_url: win.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { if (j.sections) renderDrawer(j.sections[DRAWER_SECTION]); else return refreshDrawer(); })
      .catch(function (err) { toast((err && err.description) || S.error); if (lineEl) lineEl.classList.remove('is-updating'); });
  }

  /* ---------------- quick view ---------------- */
  function modal() { return $('#LLQuickView'); }
  function openModal(url, mode, trigger) {
    var m = modal(); if (!m) { win.location.href = url; return; }
    lastFocus = trigger || doc.activeElement;
    var content = $('[data-ll-modal-content]', m);
    content.innerHTML = '<div class="ll-modal__loading" role="status" aria-label="Loading"></div>';
    m.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add('is-open'); }); });
    overlay(true); lock(true);
    var u = url.split('?')[0];
    fetch(u + '?section_id=ll-quick-view', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('qv'); return r.text(); })
      .then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var qv = tmp.querySelector('[data-ll-qv]');
        if (!qv) throw new Error('qv');
        content.innerHTML = ''; content.appendChild(qv);
        bindQuickView(qv, mode);
        var focusEl = mode === 'add' ? ($('.ll-opt input', qv) || $('[data-ll-qv-submit]', qv)) : $('.ll-qv__title', qv);
        if (focusEl) { if (focusEl.tagName === 'H2') focusEl.setAttribute('tabindex', '-1'); focusEl.focus({ preventScroll: true }); }
      })
      .catch(function () { win.location.href = url; });
  }
  function closeModal(silent) {
    var m = modal(); if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    if (!silent) { overlay(false); lock(false); }
    setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, 500);
    if (!silent && lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  function bindQuickView(qv, mode) {
    var data = {};
    try { data = JSON.parse($('[data-ll-qv-json]', qv).textContent); } catch (e) { data = { variants: [] }; }
    var variants = data.variants || [];
    var form = $('[data-ll-qv-form]', qv);
    var idInput = $('[data-ll-qv-id]', qv);
    var submit = $('[data-ll-qv-submit]', qv);
    var msg = $('[data-ll-qv-msg]', qv);
    var price = $('[data-ll-qv-price]', qv);
    var sets = $all('[data-ll-opt]', qv);
    var gallery = $('[data-ll-qv-gallery]', qv);
    var dots = $all('.ll-qv__dots span', qv);

    /* Quick add on multi-option products: every option with more than one
       value must be chosen explicitly — nothing is added with a silent default. */
    var chosen = sets.map(function (fs) {
      var inputs = $all('input', fs);
      if (mode === 'add' && inputs.length > 1) { inputs.forEach(function (i) { i.checked = false; }); return null; }
      var c = $('input:checked', fs); return c ? c.value : (inputs[0] && inputs[0].value);
    });

    function current() {
      if (chosen.indexOf(null) > -1) return null;
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0] || null;
    }
    function availabilityHints() {
      sets.forEach(function (fs, oi) {
        $all('input', fs).forEach(function (input) {
          var ok = variants.some(function (v) {
            if (!v.available || v.options[oi] !== input.value) return false;
            return v.options.every(function (o, j) { return j === oi || chosen[j] === null || o === chosen[j]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function optionName(fs) { var l = fs.querySelector('legend'); return l && l.firstChild ? l.firstChild.textContent.trim().toLowerCase() : 'an option'; }
    function update() {
      var v = current();
      availabilityHints();
      sets.forEach(function (fs, i) { var l = $('[data-ll-opt-label]', fs); if (l) l.textContent = chosen[i] || ''; });
      if (!v) {
        idInput.value = '';
        var missing = sets.filter(function (fs, i) { return chosen[i] === null; });
        if (missing.length) {
          submit.disabled = false;
          submit.dataset.missing = '1';
          submit.textContent = (S.choose || 'Please choose') + ' ' + optionName(missing[0]);
        } else {
          submit.dataset.missing = '';
          submit.disabled = true;
          submit.textContent = S.unavailable || 'Unavailable';
        }
        return;
      }
      submit.dataset.missing = '';
      idInput.value = v.id;
      submit.disabled = !v.available;
      submit.textContent = v.available ? 'Add to bag' : (S.soldOut || 'Sold out');
      var sale = v.compare_at_price > v.price;
      price.className = 'll-price' + (sale ? ' ll-price--sale' : '');
      price.innerHTML = '<span class="ll-price__now">' + formatMoney(v.price) + '</span>' + (sale ? '<s class="ll-price__was">' + formatMoney(v.compare_at_price) + '</s><span class="ll-price__save">Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>' : '');
      if (v.media_id && gallery) {
        var slide = gallery.querySelector('[data-media-id="' + v.media_id + '"]');
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      msg.textContent = '';
    }
    sets.forEach(function (fs, i) {
      fs.addEventListener('change', function (e) { if (e.target.name) { chosen[i] = e.target.value; update(); } });
    });
    $all('[data-ll-step]', qv).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.llStep, 10));
      });
    });
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var w = gallery.firstElementChild ? gallery.firstElementChild.getBoundingClientRect().width : 1;
        var i = Math.round(gallery.scrollLeft / (w || 1));
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submit.dataset.missing === '1' || !idInput.value) {
        var firstMissing = sets.filter(function (fs, i) { return chosen[i] === null; })[0];
        msg.textContent = submit.textContent;
        if (firstMissing) { var fi = $('input', firstMissing); if (fi) fi.focus(); }
        return;
      }
      var qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
      addToCart({ items: [{ id: +idInput.value, quantity: qty }] }, submit).catch(function () {});
    });
    update();
  }

  /* ---------------- global listeners ---------------- */
  doc.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-ll-cart-open]'))) {
      if (drawer()) { e.preventDefault(); lastFocus = t; openDrawer(); }
      return;
    }
    if ((t = e.target.closest('[data-ll-add]'))) {
      e.preventDefault();
      addToCart({ items: [{ id: +t.getAttribute('data-ll-add'), quantity: 1 }] }, t).catch(function () {});
      return;
    }
    if ((t = e.target.closest('[data-ll-quick]'))) {
      e.preventDefault();
      openModal(t.getAttribute('data-ll-quick'), t.getAttribute('data-ll-mode'), t);
      return;
    }
    if ((t = e.target.closest('[data-ll-close]'))) {
      if (t.closest('#LLCartDrawer')) closeDrawer(); else closeModal();
      return;
    }
    if (e.target.closest('[data-ll-overlay]')) { closeDrawer(); closeModal(); return; }
    if ((t = e.target.closest('#LLCartDrawer [data-ll-qty]'))) {
      var line = t.closest('[data-line-key]');
      changeLine(line.getAttribute('data-line-key'), parseInt(t.getAttribute('data-ll-qty'), 10), line);
    }
  });
  doc.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('#LLCartDrawer [data-ll-qty-input]')) {
      var line = e.target.closest('[data-line-key]');
      changeLine(line.getAttribute('data-line-key'), parseInt(e.target.value, 10) || 0, line);
    }
  });
  doc.addEventListener('keydown', function (e) {
    var d = drawer(), m = modal();
    if (e.key === 'Escape') { if (m && m.classList.contains('is-open')) closeModal(); else closeDrawer(); }
    if (d && d.classList.contains('is-open')) trapFocus(d, e);
    else if (m && m.classList.contains('is-open')) trapFocus(m, e);
  });

  /* Route theme product forms (product page, Ella quick shop) into the drawer.
     Capture phase, so the Love Lace drawer is used instead of the old popup. */
  var ADD_BTN = 'form[action*="/cart/add"] [type="submit"][name="add"], form[action*="/cart/add"] .product-form__submit, form[action*="/cart/add"] [data-btn-addtocart], form[action*="/cart/add"] #product-add-to-cart';
  function interceptForm(form, btn, e) {
    if (!form || form.hasAttribute('data-ll-qv-form') || form.hasAttribute('data-ll-native')) return;
    if (!drawer()) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('disabled'))) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) { form.reportValidity(); e.preventDefault(); e.stopImmediatePropagation(); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(new FormData(form), btn).catch(function () {});
  }
  win.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(ADD_BTN);
    if (btn) interceptForm(btn.closest('form'), btn, e);
  }, true);
  win.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) interceptForm(form, form.querySelector('[type="submit"]'), e);
  }, true);

  win.LoveLaceShop = { add: addToCart, openCart: openDrawer, refreshCart: refreshDrawer, quickView: openModal };
})();
